<template>
  <Teleport to="body">
    <cl-modal
      :visible="isModalVisible"
      :size="'md'"
      test-id="feature-announcement-modal"
      @on-close="onModalClose"
      :hide-header="true"
      :hide-footer="true"
    >
      <slot name="body">
        <div class="tw-flex tw-flex-col tw-gap-2">
          <cl-icon-megaphone
            class="tw-place-self-center"
            data-test-id="feature-announcement-modal-icon"
          />

          <div
            class="tw-text-center tw-text-lg tw-font-semibold"
            data-test-id="feature-announcement-modal-feature-title"
          >
            Assign Roles to Your Team!
          </div>
          <div
            class="tw-text-left"
            data-test-id="feature-announcement-modal-feature-text"
          >
            You can now control who can view, manage, or fully access your
            settings and data by assigning read-only, administrator, or super
            admin roles to your admins. Go to Settings > Administrators.
          </div>

          <div class="tw-place-self-center tw-mt-4">
            <cl-button
              variant="secondary-outline"
              data-test-id="feature-announcement-modal-learn-more-button"
              @on-click="navigateToLink"
            >
              <span>{{ $t("button-learn-more") }}</span>
            </cl-button>
            <cl-button
              variant="secondary"
              data-test-id="feature-announcement-modal-got-it-button"
              @on-click="onModalClose"
            >
              <span>{{ $t("button-got-it") }}</span>
            </cl-button>
          </div>
        </div>
      </slot>
    </cl-modal>
  </Teleport>
</template>

<script setup lang="ts">
import { computed } from "vue";

import {
  isFeatureAnnouncementModalSeen,
  setCookie,
} from "./utils/new-features-announcement";
import { EXTERNAL_DOCS_LINKS } from "@/constants/externalDocsLinks.ts";
import { trackEvent } from "@/utils/track-event";

const isModalVisible = computed(() => !isFeatureAnnouncementModalSeen.value);

const navigateToLink = () => {
  trackEvent({
    category: "Feature Announcement",
    action: "Feature Announcement learn more link clicked",
    name: EXTERNAL_DOCS_LINKS.PLATFORM_RELEASE_BLOG,
  });
  window.open(EXTERNAL_DOCS_LINKS.PLATFORM_RELEASE_BLOG, "_blank");
};
const onModalClose = () => setCookie("assign_roles_to_your_team");
</script>
